import { useEffect, useState } from 'react';

/**
 * Rubriques de gestion épinglées dans l'en-tête (Mon compte, mémorisées sur le poste comme le
 * thème) : `null` = règle par défaut (les rubriques où la personne a le plus d'écrans).
 */
export const RUBRIQUES_KEY = 'oasis.rubriques';
const EVENEMENT = 'oasis:rubriques';

/** Valeur mémorisée lue prudemment : toute valeur illisible vaut la règle par défaut. */
export function lireEpinglees(valeur: string | null): string[] | null {
  if (valeur === null) return null;
  try {
    const v: unknown = JSON.parse(valeur);
    return Array.isArray(v) && v.every((x) => typeof x === 'string') ? v : null;
  } catch {
    return null;
  }
}

function lireStockage(): string[] | null {
  try {
    return lireEpinglees(window.localStorage.getItem(RUBRIQUES_KEY));
  } catch {
    return null;
  }
}

function ecrireStockage(epinglees: readonly string[] | null): void {
  try {
    if (epinglees === null) window.localStorage.removeItem(RUBRIQUES_KEY);
    else window.localStorage.setItem(RUBRIQUES_KEY, JSON.stringify(epinglees));
  } catch {
    // stockage indisponible (navigation privée) : choix non conservé
  }
}

/** Rubriques épinglées, partagées entre l'en-tête et Mon compte (même onglet et autres onglets). */
export function useMesRubriques(): {
  epinglees: string[] | null;
  choisir: (epinglees: readonly string[] | null) => void;
} {
  const [epinglees, setEpinglees] = useState<string[] | null>(lireStockage);
  useEffect(() => {
    const relire = (): void => {
      setEpinglees(lireStockage());
    };
    window.addEventListener(EVENEMENT, relire);
    window.addEventListener('storage', relire);
    return () => {
      window.removeEventListener(EVENEMENT, relire);
      window.removeEventListener('storage', relire);
    };
  }, []);
  const choisir = (suivant: readonly string[] | null): void => {
    ecrireStockage(suivant);
    window.dispatchEvent(new Event(EVENEMENT));
  };
  return { epinglees, choisir };
}
